import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <header className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="text-[28px] font-extrabold leading-tight tracking-tight sm:text-[34px]">{title}</h1>
        {description && (
          <p className="mt-1 max-w-prose text-sm leading-relaxed text-ink-muted">
            {description}
          </p>
        )}
      </div>
      {action}
    </header>
  );
}
